export type PaymentRequestStatus = 'rejected' | 'received' | 'approved' | 'pending';

export interface PaymentRequestStatusSource {
  approved_at?: string | null;
  issued_at?: string | null;
  rejected_at?: string | null;
}

export function getPaymentRequestStatus(row: PaymentRequestStatusSource): PaymentRequestStatus {
  if (row.rejected_at) {
    return 'rejected';
  }
  if (row.issued_at) {
    return 'received';
  }
  if (row.approved_at) {
    return 'approved';
  }
  return 'pending';
}

export function getPaymentRequestStatusLabel(status: PaymentRequestStatus): string {
  switch (status) {
    case 'rejected':
      return 'ОТКЛОНЕНО';
    case 'received':
      return 'ПОЛУЧЕНО';
    case 'approved':
      return 'СОГЛАСОВАНО';
    case 'pending':
      return 'НА СОГЛАСОВАНИИ';
    default:
      return 'НА СОГЛАСОВАНИИ';
  }
}

export const PAYMENT_REQUEST_STATUS_FILTER_OPTIONS: PaymentRequestStatus[] = [
  'pending',
  'approved',
  'received',
  'rejected',
];
